import { GuidT } from '@/types/common';
import { AiTaskModelIF } from '@/api/aiApi/types';
import { delay } from '@/helpers/utils';
import { TASK_STATUSES } from '@/constants/statuses';

export const DELAY_TIME_1000 = 1000;
export const MAX_ATTEMPTS = 100;

export const pollingAiTask = async (
    taskGuid: GuidT,
    getAiTask: (guid: GuidT) => Promise<AiTaskModelIF>,
): Promise<AiTaskModelIF | null> => {
    let attempts = 0;

    while (attempts < MAX_ATTEMPTS) {
        const task = await getAiTask(taskGuid);

        if (task.status === TASK_STATUSES.Completed) {
            return task;
        }

        if (task.status === TASK_STATUSES.Failed) {
            return null;
        }

        attempts++;

        if (attempts < MAX_ATTEMPTS) {
            await delay(DELAY_TIME_1000);
        }
    }

    return null;
};
